export const PAGE_TITLE = "CEU Courses";

export const PAGE_TEXT =
  "As a member of the <b>International Association of Interpersonal Hypnotherapists (IAIH)</b>, you are required to complete <b>30 hours of continuing education units (CEUs)</b> every two years. These CEUs can be earned through IAIH's extensive online training library or from other reputable hypnotherapy training programs.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1F2c8nvBLwxIePaEcsRXPFBCMFZ33knXD/preview";

export const SECTION_TITLE =
  "IAIH offers a variety of internally generated CEU courses, including:";

export const FOOTER_TEXT_CEU_LIST =
  "For a comprehensive list of available CEU courses, please visit the IAIH CEU Courses page.";

export const LINK_BOX_TITLE = "Institute of Hypnotherapy";

export const LINK_BOX_URL = "https://www.instituteofhypnotherapy.com/ceu/";

export const FOOTER_TEXT_OTHER_CEUS =
  "If you have completed CEUs from other reputable hypnotherapy trainings, please ensure they align with IAIH standards and submit the necessary documentation for approval.";

export const FOOTER_TEXT_STAYING_CURRENT =
  "Staying current with your continuing education not only fulfills membership requirements but also enhances your skills and knowledge in the field of hypnotherapy.";

export const COURSES_DATA = [
  {
    id: 1,
    title: "A Course in Miracles",
    text: "A 10-hour course exploring spiritual principles and their application in hypnotherapy.",
    linkBox: false,
    linkBoxText: "Institute of Hypnotherapy",
    link: "https://www.instituteofhypnotherapy.com/ceu/a-course-in-miracles/",
    image: require("../../../assets/images/course-in-miracles.png"),
  },
  {
    id: 2,
    title: "Advanced Life Mastery Course:",
    text: "A workshop dedicated to achieving success in various aspects of life.",
    linkBox: false,
    linkBoxText: "Institute of Hypnotherapy",
    link: "https://www.instituteofhypnotherapy.com/ceu/advanced-life-mastery-course/",
    image: require("../../../assets/images/life-mastery-course.jpg"),
  },
  {
    id: 3,
    title: "Yoga Sutras of Patanjali",
    text: "A course examining the relationship between the Yoga Sutras and hypnotherapy practices.",
    linkBox: false,
    linkBoxText: "Institute of Hypnotherapy",
    link: "https://www.instituteofhypnotherapy.com/ceu/yoga-sutras-of-patanjali/",
    image: require("../../../assets/images/yoga-course.jpeg"),
  },
  {
    id: 4,
    title: "Interpersonal Hypnotherapist Certification Course",
    text: "A 22-hour course focusing on interpersonal hypnotherapy techniques.",
    linkBox: false,
    linkBoxText: "Institute of Hypnotherapy",
    link: "https://www.instituteofhypnotherapy.com/ceu/interpersonal-hypnotherapist-certification-course/",
    image: require("../../../assets/images/interpersonal-hypnotherapy-course.jpg"),
  },
];
